import { render, staticRenderFns } from "./BuyerVerificationsTable.vue?vue&type=template&id=74c61980&"
import script from "./BuyerVerificationsTable.vue?vue&type=script&lang=js&"
export * from "./BuyerVerificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports